<template>
  <CCard class="question__card">
    <CCardHeader> سوال</CCardHeader>
    <CCardBody class="d-flex align-items-start h-100">
      <CForm class="w-100">
        <CTextarea v-model="form.text" class="text-sm" label="صورت سوال"/>
        <div class="text-sm">افزودن فایل سوال</div>
        <UploadExamFile
            v-model="form.files"
            cat="ETQ"
            @upload-file="onUploadExamFile"
        />
        <CInput
            v-model="form.mark"
            class="text-sm"
            label="بارم سوال"
            type="number"
        />
      </CForm>
    </CCardBody>
    <CCardFooter class="d-flex justify-content-between align-items-center">
      <CButton class="px-sm-5 py-sm-2" color="primary" @click="addQuestion">
        ثبت سوال
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
import UploadExamFile from "../UploadExamFile/UploadExamFile.vue";

export default {
  components: {UploadExamFile},

  data() {
    return {
      form: {
        text: "",
        files: "",
        mark: 1
      },
      loading: false,
    };
  },
  methods: {
    onUploadExamFile(file) {
      this.form.files = file;
    },
    addQuestion() {
      this.$emit("add-question", this.form);
    },
  },
};
</script>

<style lang="scss" scoped></style>